import { render } from "./UserListForm.vue?vue&type=template&id=19e8b2c4&scoped=true"
import script from "./UserListForm.vue?vue&type=script&lang=js"
export * from "./UserListForm.vue?vue&type=script&lang=js"

import "./UserListForm.vue?vue&type=style&index=0&id=19e8b2c4&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e8b2c4"]])

export default __exports__